import axios from '../axios'
import URL from '@/_url_'

let lang = localStorage.lang;

export default {
    state: {
        // 
        // ******************* 首页 ***************************
        //
        main_carousel: [],// 首页轮播图
        menu: [],// 轮播图侧菜单栏

        star: [],// 明星单品
        hot: [],// 热销商品

        main_banner: [], // 分类间广告图片
        // 
        // ******************* 列表页 ***************************
        // 
        recommend_goods: [], // 为你推荐商品
    },
    mutations: {
        // 
        // ******************* 首页 ***************************
        // 
        setMainCarousel(state, arg){ // 写入首页轮播图广告
            // 判断是否需要添加前缀
            for(var item of arg){
                if(item.image.indexOf('http')<0){
                    item.image=URL.imgUrl+item.image;
                }
            }
            state.main_carousel = arg
        },
        setMenu(state, arg){ // 写入轮播图侧菜单
            state.menu = arg;
        },

        setStar(state, arg){ // 明星单品写入
            // 判断是否需要添加前缀
            for(var item of arg){
                if(item.advertising_image.indexOf('http')<0){
                    item.advertising_image=URL.imgUrl+item.advertising_image;
                }
            }
            state.star = arg;
        },
        setHot(state, arg){ // 人气商品写入
            // 判断是否需要添加前缀
            for(var item of arg){
                let newImgs = [];
                newImgs = item.goods_images.split(",");
                for(var i in newImgs){
                    if(newImgs[i].indexOf('http') < 0){
                        newImgs[i] = URL.imgUrl+newImgs[i];
                    }
                }
                item.goods_images = newImgs;
            }
            state.hot = arg;
        },

        setMainBanner(state, arg){
            state.main_banner = arg;
        },
        // 
        // ******************* 列表页 ***************************
        // 
        setRecommend(state, arg){ // 写入为你推荐商品
            // 判断是否需要添加前缀
            for(let item of arg){
                let newImgs = [];
                newImgs=item.goods_images.split(",");
                for(var i in newImgs){
                    if(newImgs[i].indexOf('http')<0){
                        newImgs[i]=URL.imgUrl+newImgs[i];
                    }
                }
                item.goods_images = newImgs;
            }
            state.recommend_goods = arg;
        }
    },
    actions: {
        // 
        // ******************* 首页 ***************************
        // 
        getMainCarousel({commit}){ // 获取首页轮播图广告
            let url = "/index/index/carousel?lang="+lang;
            axios.get(url).then((res) => {
                if(res.data.code == 1){
                    commit("setMainCarousel",res.data.carousellist);
                }
            }).catch(() => {})
        },
        getMenu({commit}){ // 获取首页菜单栏
            let url = "/index/index/category?lang="+lang;
            axios.get(url).then((res)=>{
                if(res.data.code==1){
                    commit('setMenu',res.data.categorylist)
                }
            })
        },

        getStar({commit}){ // 获取明星单品
            let url = "/index/index/advertising?lang="+lang+"&position=1";
            axios.get(url).then((res)=>{
                if(res.data.code==1){
                    commit('setStar',res.data.advertisinglist)
                }
            })
        },
        getHot({commit}){ // 获取热销商品
            let url = "/index/index/hot?lang="+lang;
            axios.get(url).then((res)=>{
                if(res.data.code==1){
                    commit('setHot',res.data.goods)
                }
            })
        },
        
        getMainBanner({ commit }){
            let url = "/index/index/advertising?lang=" + lang + "&position=0";
            axios.get(url).then((res) => {
                if(res.data.code == 1){
                    commit("setMainBanner", res.data.advertisinglist);
                }
            }).catch(() => {})
        },
        // 
        // ******************* 列表页 ***************************
        // 
        getRecommend({commit}){
            let url = "/index/goodslist/recommend?lang="+lang;
            axios.get(url).then((res) => {
                if(res.data.code == 1){
                    commit('setRecommend',res.data.goods)
                }
            }).catch(() => {})
        }
    }
}